<template>
    <div>
        <!-- 根据入驻状态显示不同内容 -->
        <component :is="currentContent" @goToComponent="handleComponentChange" :certified="componentParams.certified">
        </component>
    </div>
</template>
<script>
import ShopEntry from './home/ShopEntry.vue'
import ShopAuthentication from './home/ShopAuthentication.vue'
import ShopInformation from './home/ShopInformation.vue'
import ShopWaiting from './home/ShopWaiting.vue'
import ShopDashboard from './home/ShopDashboard.vue'


export default {
    name: 'SellerHome',
    components: {
        ShopEntry,
        ShopAuthentication,
        ShopInformation,
        ShopWaiting,
        ShopDashboard
    },
    // 接收来自父组件的certified参数
    props: {
        certified: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            currentContent: '', // 默认显示免费开店页面
            componentParams: {
                certified: ''
            }
        }
    },
    // 监听certified参数的变化
    watch: {
        certified: {
            handler(newCertified) {
                this.setInitialContent();
            },
            immediate: true
        }
    },
    mounted() {
        // 确保每次组件被挂载时都重新设置内容
        this.setInitialContent();
    },
    methods: {
        setInitialContent() {
            switch (Number(this.certified)) {
                case 0: // 未入驻
                    this.currentContent = 'ShopEntry'
                    break
                case 1: // 审核中
                    this.currentContent = 'ShopWaiting'
                    this.componentParams.certified = this.certified.toString()
                    break
                case 3: // 驳回
                    this.currentContent = 'ShopWaiting'
                    this.componentParams.certified = this.certified.toString()
                    break
                case 5: // 已入驻
                    this.currentContent = 'ShopDashboard'
                    break
            }
        },
        handleComponentChange(componentName, params) {
            if (params) {
                this.componentParams = { ...this.componentParams, ...params }
            }
            this.currentContent = componentName;
        }
    }
}
</script>

<style scoped></style>